import { render, staticRenderFns } from "./listAndContactTable.vue?vue&type=template&id=3b1fc22f"
import script from "./listAndContactTable.vue?vue&type=script&lang=js"
export * from "./listAndContactTable.vue?vue&type=script&lang=js"
import style0 from "./listAndContactTable.vue?vue&type=style&index=0&id=3b1fc22f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports